import React, { useContext } from 'react';
import { EventDetailsContext } from '../../context/event_details.context';

interface CtaSectionProps {
  position: 'center' | 'start' | 'end';
}

const CtaSection: React.FC<CtaSectionProps> = ({ position }) => {
  const {
    isSignedIn,
    onCtaClick,
    onLoginCtaClick,
    onRegisterCtaClick,
  } = useContext(EventDetailsContext);

  const sectionIsCentered = position === 'center';

  const renderLoginRegisterCTAs: JSX.Element = (
    <>
      <div className={`${sectionIsCentered ? 'col-md-auto col-7' : 'col-auto'}`}>
        <button
          className='btn btn-primary float-md-end w-100'
          onClick={onLoginCtaClick}
          data-testid='cta-button-login'
        >
          Log in to register
        </button>
      </div>

      <div className={`${sectionIsCentered ? 'col-md-auto col-7' : 'col-auto'}`}>
        <button
          className='btn btn-primary float-md-start w-100'
          onClick={onRegisterCtaClick}
          data-testid='cta-button-sign-up'
        >
          Sign up to register
        </button>
      </div>
    </>
  );

  const renderSaveYourSpotCTA: JSX.Element = (
    <div className={`${sectionIsCentered ? 'col' : 'col-auto'}`}>
      <button
        className='btn btn-primary'
        onClick={onCtaClick}
        data-testid='cta-button-save-your-spot'
      >
        Save your spot now
      </button>
    </div>
  );

  return (
    <div
      id='cta-section'
      data-testid='cta-section'
      className={`row d-flex justify-content-${position} g-3 m-0`}
    >
      {isSignedIn ? renderSaveYourSpotCTA : renderLoginRegisterCTAs}
    </div>
  );
};

CtaSection.defaultProps = {
  position: 'center',
};

export default CtaSection;
